import React, { FunctionComponent } from 'react'
import icon from '../../assets/icon_logo.png'
import img from './img.jpg'
import './PcFooter.scss'
interface FooterProps {}

const PcFooter: FunctionComponent<FooterProps> = () => {
    //     商务合作：0571-89774660
    // 市场合作：marketing@faceunity.com
    // 简历投递：ZP@faceunity.com
    // 杭州总部：杭州市拱墅区余杭塘路515号莱茵矩阵国际2座6层
    // 北京分部：北京市海淀区知春路6号锦秋国际大厦B座308室
    const list = [
        { title: '商务合作', content: '0571-89774660' },
        { title: '市场合作', content: 'marketing@faceunity.com' },
        { title: '简历投递', content: 'ZP@faceunity.com' },
        { title: '杭州总部', content: '杭州市拱墅区余杭塘路515号莱茵矩阵国际2座6层' },
        { title: '北京分部', content: '北京市海淀区知春路6号锦秋国际大厦B座308室' },
    ]
    return (
        <div className="pc-footer">
            <div className="content">
                <img src={icon} alt="" />
                <h4>联系我们</h4>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <div>
                        {list.map(item => {
                            return (
                                <p>
                                    {item.title}:{item.content}
                                </p>
                            )
                        })}
                    </div>
                    <div className="img">
                        <img src={img} alt="" />
                    </div>
                </div>

                <div className="line"></div>
                <div className="comp">
                    <p>
                        ©2016-2019 杭州相芯科技有限公司版权所有|浙ICP备16022736号丨浙公网安备
                        33010502005491号{' '}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default PcFooter
